export function extractYouthCommunityRaw(youthCommunity) {
  if (!youthCommunity) {
    return null;
  }
  if (typeof youthCommunity === 'string') {
    return youthCommunity;
  }
  if (typeof youthCommunity === 'object') {
    return youthCommunity._id || youthCommunity.value || null;
  }
  return null;
}

export function resolveYouthCommunityId(raw, communities) {
  if (!raw || raw === 'N/A') {
    return null;
  }
  if (!communities || communities.length === 0) {
    return raw;
  }
  const foundById = communities.find((c) => c._id === raw);
  if (foundById) {
    return foundById._id;
  }
  const foundByValue = communities.find((c) => c.value === raw);
  if (foundByValue) {
    return foundByValue._id;
  }
  return raw;
}

export function getYouthCommunityIdForApi(user, communities) {
  const raw = extractYouthCommunityRaw(user?.youthCommunity);
  return resolveYouthCommunityId(raw, communities);
}
